import React, { useEffect, useState } from "react";
import "./Coupans.scss";
import { TitleBar } from "../../Global/TitleBar/TitleBar";
import {
  InputLabel,
  InputType,
  SelectBorder,
} from "../../Global/GlobalFormElement";
import { RedBackgroundButton } from "../../Global/GlobalButton";
import { TopBar } from "../TopBar/TopBar";
import { EXCHNAGE_URL } from "../../../Url/Url";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { useLoading } from "../../LoadingContext";

export const Coupans = () => {

  const [categories, setCategories] = useState([])
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const initialEventId = String(eventIdGet);
    const { setLoading } = useLoading(); 

  const [formValues, SetFormValues] = useState({
    eventId: "",
    // category: "",
    coupon_name: "",
    coupon_code: "",
    percent_off: null,
    coupon_amount: null,
    start_date: "",
    end_date: ""
  })
  console.log("Stored eventId showww:", initialEventId);
  const token = localStorage.getItem("token")

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    SetFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
      ...(name === "percent_off" && value ? { coupon_amount: "" } : {}),
      ...(name === "coupon_amount" && value ? { percent_off: "" } : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        eventId: initialEventId,
        coupon_name: formValues.coupon_name,
        coupon_code: formValues.coupon_code,
        percent_off: formValues.percent_off ? formValues.percent_off : null,  
      coupon_amount: formValues.coupon_amount ? formValues.coupon_amount : null,
        start_date: formValues.start_date,
        end_date: formValues.end_date,
      };

      const response = await axios.post(
        `${EXCHNAGE_URL}/couponCreate`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Coupon successfully Created!");
        SetFormValues({
          eventId: "",
          coupon_name: "",
          coupon_code: "",
          percent_off: "",
          coupon_amount: "",
          start_date: "",
          end_date: "",
        });
      } else {
        toast.error("Error while submitting coupon.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error while submitting coupon.");
    } finally {
      setLoading(false);
  }
  };

  console.log("Categories", categories)
  return (
    <div>
      <div className="coupans_div">
        <TitleBar title="Coupons" />

        <div className="coupans_white_bg">
          <TopBar titleheading="Coupons" />
          <form className="coupan_form" onSubmit={handleSubmit}>
  <div className="coupans_row">

    <div className="coupans_label_lg">
      <div className="coupans_label_cont">
        <InputLabel>
          Coupon Name <span style={{ color: "#c32728" }}>*</span>
        </InputLabel>
      </div>
      <InputType
        type="text"
        name="coupon_name"
        placeholder="Enter Coupon Name"
        value={formValues.coupon_name}
        onChange={handleChange}
      />
    </div>

    <div className="coupans_label_lg">
      <div className="coupans_label_cont">
        <InputLabel>
          Coupon Code <span style={{ color: "#c32728" }}>*</span>
        </InputLabel>
      </div>
      <InputType
        type="text"
        name="coupon_code"
        placeholder="Coupon Code"
        value={formValues.coupon_code}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="coupans_row">
    <div className="coupans_label_lg">
      <div className="coupans_label_cont">
        <InputLabel>
         {" Coupon %  (You can only select one Between Percentage and Amount)"}<span style={{ color: "#c32728" }}>*</span>
        </InputLabel>
      </div>
      <InputType
        type="number"
        name="percent_off"
        value={formValues.percent_off}
        onChange={handleChange}
        placeholder="Enter percentage (%)"
        min="0"
        max="100"
        disabled={!!formValues.coupon_amount} 
      />
    </div>

    <div className="coupans_label_lg">
      <div className="coupans_label_cont">
        <InputLabel>
          Coupon Amount <span style={{ color: "#c32728" }}>*</span>
        </InputLabel>
      </div>
      <InputType
        type="number"
        name="coupon_amount"
        placeholder="Enter Amount"
        value={formValues.coupon_amount}
        onChange={handleChange}
        disabled={!!formValues.percent_off}
      />
    </div>
  </div>

  <div className="coupans_row">
    <div className="coupans_label_lg">
      <div className="coupans_label_cont">
        <InputLabel>
          Start Date <span style={{ color: "#c32728" }}>*</span>
        </InputLabel>
      </div>
      <InputType
        type="date"
        name="start_date"
        placeholder="Select Date"
        value={formValues.start_date}
        onChange={handleChange}
      />
    </div>

    <div className="coupans_label_lg">
      <div className="coupans_label_cont">
        <InputLabel>
          End Date <span style={{ color: "#c32728" }}>*</span>
        </InputLabel>
      </div>
      <InputType
        type="date"
        name="end_date"
        placeholder="Select Date"
        value={formValues.end_date}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="coupans_btndiv">
    <RedBackgroundButton>Submit</RedBackgroundButton>
  </div>
</form>

        </div>
      </div>
    </div>
  );
};
